import { useGlobal } from '@/hooks';

export default function withGlobal(Component) {
  return function WithGlobalComponent(props) {
    const globals = useGlobal();

    return <Component {...props} globals={globals} />;
  };
}
